module.exports = __webpack_public_path__ + "img/google.cd9146cd.svg";